import React from "react";
import { useState } from "react";
import { FC } from "react";
import "./Login.css";

type LoginProps = {
  tittle: string;
};

const Login: FC<LoginProps> = (props) => {
  console.log("rendes");

  const [val, setVal] = useState<string>('ash');
  return (
    <div className="login">
      {props.tittle}
      <div className="login__form">
        Username <input type="text" />
        <div>
          Password <input type="text" value={val} onChange={(e) => {setVal(e.target.value)}} />
        </div>
        <button>Login</button>
      </div>
    </div>
  );
};

export default Login;
